import { IServiceSettings } from '../../../../assets/configuration';
import './css/communityEngagement.css';

export const CommunityEngagement = (props: { serviceSettings: IServiceSettings }) => {
    return (
        <div className="section-container community-section">
            <h1 className="title-center title fw-bold">Community Engagement Made Simple</h1>
            <div className="fluid-image-animation-wrapper">
                <div className="content-fit">
                    <img
                        src={`${props.serviceSettings.hostUrl}/images/public/connecting.png`}
                        alt="Connecting"
                    />
                    <h3><span>For City Leaders</span></h3>
                    <div className="mx-auto ps-5">
                        <ul>
                            <li>Direct communication with residents</li>
                            <li>Real-time feedback collection</li>
                            <li>Simplified resource sharing</li>
                            <li>Emergency notifications</li>
                        </ul>
                    </div>
                </div>
                <div className="content-fit">
                    <img
                        src={`${props.serviceSettings.hostUrl}/images/public/engage.png`}
                        alt="Messaging"
                    />
                    <h3><span>For Residents</span></h3>
                    <div className="mx-auto ps-5">
                        <ul>
                            <li>All city services in one place</li>
                            <li>Voice in community development</li>
                            <li>Important updates instantly</li>
                        </ul>
                    </div>
                </div>
                <div className="content-fit">
                    <img
                        src={`${props.serviceSettings.hostUrl}/images/public/civic.png`}
                        alt="Civic image"
                    />
                    <h3><span>For Community</span></h3>
                    <div className="mx-auto ps-5">
                        <ul>
                            <li>Digital</li>
                            <li>Engaged</li>
                            <li>Informed</li>
                            <li>Transparent Government</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
